import React from 'react';
import { compose, pure } from 'recompose';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = theme => ({
  registerButton: {
    padding: '6px 10px',
    width: '85px',
    height: '85px',
    display: 'block',
    fontSize: '0.9rem',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      width: '100%',
      minWidth: '100%'
    }
  },
  whiteButton: {
    border: '1px solid #2EC1B4'
  }
});

const enhance = compose(pure);

const button = enhance(
  ({ classes, onClickAction = null, disabled = false }) => {
    return (
      <Button
        className={classNames(classes.registerButton, classes.whiteButton)}
        onClick={onClickAction}
        disabled={disabled}
      >
        店舗
        <br />
        登録
      </Button>
    );
  }
);

export default withStyles(styles)(button);
